import React, { memo, useContext, useEffect, useMemo, useRef, useState } from "react";
import { format } from "date-fns";
import Pagination from "../shared/Pagination";

import GLOBAL from "../../global";
import CONSTANT from "../../constants/Constant";
import AppContext from "../../contexts/AppContext";
import examService from "../../services/ExamService";
import FysicalScoreReportView from "../report/FysicalScoreReportView";
import ReportJsonViewer from "../report/ReportJsonViewer";
import Refresh from "../shared/Refresh";
import { getArrayFromObject, getBodyRegionsValueLabelObjectArray } from "../../utils/Utils";
import MmhTable from "../shared/table/datatable/MmhTable";
import DisplayUrlContent from "../shared/DisplayUrlContent";
import SelectOption from "../my-assessments/SelectOption";
// import dropdownBtn from "../../assets/img/mmh-table/dropDown.svg";
// import initialBtn from "../../assets/img/report/initial.svg";
// import followUpBtn from "../../assets/img/report/followUp.svg";
// import clickForReportBtn from "../../assets/img/report/clickForReport.svg";
import MultipleSelectOption from "../my-assessments/MultipleSelectOption";
import viewReportBtn from "../../assets/img/myAssessmensList/eyeIcon.svg";
import {resetEventData, setEventData} from "../../features/askEmma/askEmmaSlice";
import {useDispatch} from "react-redux";
import "../../assets/sass/components/my-reports/_myReportsDetails.scss";
import reportJsonTestData from '../../report.json';
import AcademicCitationModal from "../shared/AcademicCitationModal";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const MyReportsDetails = memo(() => {
    const { userInfo } = useContext(AppContext);
    const { EnableFysicalScore, IsPatientReportAvailable } = userInfo.Permissions;
    const dispatch = useDispatch();
    const [assessments, setAssessments] = useState([]);
    const [fysicalReportView, setFysicalReportView] = useState(false);
    const [fysicalRportUrl, setFysicalRportUrl] = useState('');
    const subscription = useRef(true);
    const [reloadMyRoms, setReloadMyRoms] = useState(false);
    const [filteredAssessments, setFilteredAssessments] = useState([]);
    const [bodyRegions, setBodyRegions] = useState([]);
    // eslint-disable-next-line
    const [followUpFilterValue, setFollowUpFilterValue] = useState(CONSTANT.FOLLOW_UP.YES_OR_NO.key)
    const [myPageSize, setMyPageSize] = useState(CONSTANT.PAGE_SIZE.TEN.value);
    const [myPageNumber, setMyPageNumber] = useState(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
    const [totalRecord, setTotalRecord] = useState(0);
    const [loading, setLoading] = useState(true);
    const [bodyRegionList, setBodyRegionList] = useState('');
    const [isFollowUp, setIsFollowUp] = useState(null);
    const [followupOption, setFollowupOption] = useState(CONSTANT.FOLLOW_UP.YES_OR_NO.key);
    const [reportUrl, setReportUrl] = useState('');
    const [testId, setTestId] = useState('');
    const [reportJsonData, setReportJsonData] = useState(null);
    const [reportJsonView, setReportJsonView] = useState(false);
    const [isLoadingReport, setIsLoadingReport] = useState(false);
    const [showCitationModal, setShowCitationModal] = useState(false);
    const [selectedCitationTestId, setSelectedCitationTestId] = useState('');
    const isHtmlEnabled = true;

    const { isSpinealignEnabled, isAcademicCitationEnabled } = useTenantFeatures();

    useEffect(() => {
        setLoading(true);
        // noinspection JSIgnoredPromiseFromCall

        _getMyAssessments();
        // eslint-disable-next-line
    }, [myPageNumber, myPageSize, bodyRegionList, isFollowUp]);

    useEffect(() => {
        // noinspection JSCheckFunctionSignatures
        setBodyRegions(getBodyRegionsValueLabelObjectArray());

        if (GLOBAL.URL_PARAMS.IS_REPORT_DOWNLOAD) {
            _getAssessmentById().then();
        }

        return () => {
            subscription.current = false;
            GLOBAL.ASSESSMENT = null;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps,
    }, []);

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        if (reloadMyRoms) {
            _getMyAssessments().then();
            setReloadMyRoms(false);
        }
        // eslint-disable-next-line
    }, [reloadMyRoms]);

    const _getMyAssessments = async () => {
        setLoading(true);
        const subscriptionType = parseInt(localStorage.getItem('SubscriptionType'), 10);
        let payload = {
            PageSize: myPageSize,
            PageNumber: myPageNumber,
            ReportStatus: 1,
            BodyRegionList: bodyRegionList ? bodyRegionList.split`,`.map(x => +x) : [],
            IsFollowUp: isFollowUp,
            Completed: true,
            Search: `${testId}`,
            SubscriptionType: subscriptionType,
        };

        const response = await examService.getAssessments(payload);
        const { data, success, error } = response;

        if (subscription.current) {
            if (!success) {
                console.error(error);
                return [];
            }

            const tempData = data || '[]';
            setAssessments(tempData['MyRomList']);
            setTotalRecord(tempData['TotalRecords']);

            commonFilter({
                data: tempData['MyRomList'],
                reportStatus: 1,
                bodyRegions: []
            });

            setLoading(false);
        }
    };

    const _getAssessmentById = async () => {
        const payload = {
            TestId: GLOBAL.URL_PARAMS.TEST_ID
        };
        const response = await examService.getAssessmentById(payload);
        const { data, success, error } = response;

        if (!success) {
            console.error(error);
            return;
        }

        const report = data || '{}';
        if (report && report['ReportUrl']) {
            setReportUrl(report['ReportUrl']);
        }
    };

    const onClickViewFysicalScoreReportCell = (row) => async () => {
        if(!IsPatientReportAvailable) return;
        const { original } = row;
        const testId = original['TestId'];

        dispatch(setEventData({ eventName: 'patientPortal_posture-report', testId: testId }));

        if (isHtmlEnabled) {
            // NEW: JSON-based report viewing (when isHtmlEnabled is true)
            // Open modal immediately with loading state
            setIsLoadingReport(true);
            setReportJsonView(true);

            // Fetch report data
            const jsonData = await _getAssessmentReportJson(testId);

            if (jsonData) {
                setReportJsonData(jsonData);
                setIsLoadingReport(false);
            } else {
                console.error('No JSON report data available for TestId:', testId);
                setIsLoadingReport(false);
                // Close modal if data fetch failed
                setReportJsonView(false);
            }
        } else {
            // OLD: URL-based report viewing (original functionality when isHtmlEnabled is false)
            const url = original['ReportUrl'];
            setFysicalRportUrl(url);
            toggleFysicalReportModal();
        }
    };

    const toggleFysicalReportModal = () => {
        if(fysicalReportView) {
            dispatch(resetEventData());
        }
        setFysicalReportView(!fysicalReportView);
    };

    const toggleReportJsonModal = () => {
        if(reportJsonView) {
            dispatch(resetEventData());
            setReportJsonData(null);
            setIsLoadingReport(false);
        }
        setReportJsonView(!reportJsonView);
    };

    const onClickCitation = (testId) => {
        setSelectedCitationTestId(testId);
        setShowCitationModal(true);
    };

    const onHideCitationModal = () => {
        setShowCitationModal(false);
        setSelectedCitationTestId('');
    };

    const hideReportContent = (e) => {
        e.preventDefault();
        setReportUrl('');
    };

    const _getAssessmentReportJson = async (testId) => {
        try {
            // TEMPORARY: Using test data from report.json file for testing
            // TODO: Replace this with your actual API endpoint that returns JSON report
            console.log('Loading report for TestId:', testId);

            // // For testing: Return the imported test data
            // if (reportJsonTestData) {
            //     return reportJsonTestData;
            // }

            // PRODUCTION CODE: Uncomment this when API is ready

            const payload = {
                TestId: testId
            };

            // This should call your API endpoint that returns the report JSON
            const response = await examService.getPatientReportData(payload);
            const { data, success, error } = response;

            if (!success) {
                console.error('API Error:', error);
                return null;
            }

            // Check if the data has the expected Message structure
            if (data && typeof data === 'object') {
                // If data already has Message property, return as is
                if (data.Message) {
                    return data;
                }
                // If data IS the message object, wrap it
                else if (data.PatientInfo || data.Narratives || data.ReportHeading) {
                    return { Message: data };
                }
            }

            console.warn('Report JSON data not in expected format for TestId:', testId);

            return null;
        } catch (error) {
            console.error('Error fetching report JSON:', error);
            return null;
        }
    };

    const columns = useMemo(
        () => [
            {
                Header: 'Test ID',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return `${original['IsFollowUp'] ? 'FOLLOW-UP ' + original['TestId'] : original['TestId']}`;
                }
            },
            {
                Header: 'Region',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return `${original['BodyRegionName']}`;
                }
            },
            {
                Header: 'Order Date',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return format(new Date(original['SubmissionDate']) || new Date(), CONSTANT.DATE_FORMAT.MMM_DD_YYYY);
                }
            },
            {
                Header: 'Sport',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return `${original['SportsType']}`;
                }
            },
            {
                Header: 'Report',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;

                    return (
                        <>
                            {!original?.['ReportUrl'] && (
                                <span>Not Completed</span>
                            )}
                            {original?.['ReportUrl'] && (
                                <>
                                <button
                                    className={`pointer button-row btn-border ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                    onClick={onClickViewFysicalScoreReportCell(cellProps.row)}>
                                    <span className="mr-flex-center">
                                        <i className="fa-regular fa-eye kt-mr-15"/> Click for Report
                                    </span>
                                </button>
                                {(isSpinealignEnabled && isAcademicCitationEnabled) && (
                                    <button
                                        className={`pointer button-row btn-border ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                        onClick={() => onClickCitation(original?.TestId)}
                                        style={{ marginLeft: '10px' }}>
                                        <span className="mr-flex-center">
                                            Citation
                                        </span>
                                    </button>
                                )}
                                </>
                            )}
                        </>
                    );
                }
            },
            {
                Header: 'Report Type',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    if (original['IsFollowUp']) {
                        return (
                            <>
                                {/*<span*/}
                                {/*    className="kt-badge kt-badge--primary kt-badge--xl kt-badge--inline kt-badge--pill">Follow Up</span>*/}
                                {/*&nbsp;{original['BaseTestId']}*/}
                                {/*<img src={followUpBtn} alt="Follow Up" />*/}
                                <button
                                    className={`btn pointer button-row btn-border`}>
                                    <span className="mr-flex-center">
                                        Follow Up
                                    </span>
                                </button>
                            </>
                        )
                    } else {
                        return (
                            // <span
                            //     className="kt-badge kt-badge--danger kt-badge--xl kt-badge--inline kt-badge--pill">Initial</span>
                            // <img src={initialBtn} alt="initial" />
                            <button
                                className={`btn button-row btn-border pointer-none`}>
                                    <span className="mr-flex-center">
                                        Initial
                                    </span>
                            </button>
                        )
                    }
                }
            }
        ],

        // eslint-disable-next-line
        []
    );

    const onChangeSelectBodyRegion = (values) => {
        const keys = values.map(item => item.value);

        if (values && values.length === 0) {
            setBodyRegionList('');
        }

        keys.map((key) => {
            if (!bodyRegionList.includes(key)) {
                if (bodyRegionList.length > 0) {
                    setBodyRegionList(bodyRegionList + ',' + key);
                } else {
                    setBodyRegionList(key + '');
                }
            }

            return null;
        });

        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
        setMyPageSize(CONSTANT.PAGE_SIZE.TEN.value);
    }

    const onChangeFollowUpOption = (value) => {
        // event.preventDefault();
        // const value = event.target.value;
        setFollowupOption(value);

        if (value === CONSTANT.FOLLOW_UP.YES.key) {
            setIsFollowUp(true);
        }
        if (value === CONSTANT.FOLLOW_UP.NO.key) {
            setIsFollowUp(false);
        }
        if (value === CONSTANT.FOLLOW_UP.YES_OR_NO.key) {
            setIsFollowUp(null);
        }

        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
        setMyPageSize(CONSTANT.PAGE_SIZE.TEN.value);

        setFollowUpFilterValue(value);
        commonFilter({ data: assessments, followUp: value });
    }

    const onKeyUpTestId = (e) => {
        e.preventDefault();
        setTestId(e.target.value);
        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
        setMyPageSize(CONSTANT.PAGE_SIZE.TEN.value);
        setReloadMyRoms(true);
    }

    const handlePageSize = (e) => {
        setMyPageSize(e.target.value);
        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
    }

    const handleRefresh = () => {
        setReloadMyRoms(true);
    }
    const getFilterByBodyRegionsData = (assessments, bodyRegionKeys) => {
        let filteredData = assessments;
        if (bodyRegionKeys?.length > 0) {
            filteredData = assessments.filter((item) => bodyRegionKeys?.includes(item?.BodyRegion));
            setFilteredAssessments(filteredAssessments);
        }
        return filteredData;
    }

    const getFilterByReportStatusData = (assessments, value) => {
        return assessments?.filter((item) => {
            if (value === CONSTANT.FILTER_BY_REPORT.IN_PROGRESS.key) {
                return !item?.['ReportUrl'];

            } else if (value === CONSTANT.FILTER_BY_REPORT.COMPLETED.key) {
                return item?.['ReportUrl'];

            } else {
                return true;
            }
        });
    }

    const getFilterByFollowUpData = (assessments, value) => {
        return assessments?.filter((item) => {
            if (value === CONSTANT.FOLLOW_UP.YES.key) {
                return item?.['IsFollowUp']

            } else if (value === CONSTANT.FOLLOW_UP.NO.key) {
                return !item?.['IsFollowUp']

            } else {
                return true;
            }
        });
    }

    const commonFilter = (
        {
            data,
            reportStatus = 1,
            bodyRegions = [],
            followUp = followUpFilterValue
        }) => {
        // const filterByReportStatusData = getFilterByReportStatusData(data, reportStatus);
        // const filterByBodyRegions = getFilterByBodyRegionsData(filterByReportStatusData, bodyRegions);
        // const filterByFollowUp = getFilterByFollowUpData(filterByBodyRegions, followUp);

        //as already api filtering the data we do not need to filter those data again
        setFilteredAssessments(data);
    }
    return (
        <>
            <div className="bg-color-white my-report w-100-percent padding-bottom-3-rem">
                <div className="filter-list display-flex justify-between">
                    <div className="display-flex gap-20px">
                        <div className='filter-item'>
                            <label htmlFor="example-text-input" >Follow up</label>

                            <div>
                                <SelectOption
                                    onChange={onChangeFollowUpOption}
                                    value={followupOption}
                                    values={getArrayFromObject(CONSTANT.FOLLOW_UP)}
                                />
                            </div>
                        </div>

                        {EnableFysicalScore && (
                            <div className='filter-item'>
                                <label htmlFor="example-text-input" >Body Region</label>

                                <MultipleSelectOption
                                    placeholder="Body Region"
                                    options={bodyRegions}
                                    onChange={onChangeSelectBodyRegion}
                                />
                            </div>
                        )}

                        <div className='filter-item'>
                            <label
                                htmlFor="example-text-input" >Test ID
                            </label>

                            <input
                                placeholder="Test ID"
                                className='filter_width_height select-option'
                                onChange={e => setTestId(e.target.value)}
                                onKeyUp={onKeyUpTestId}
                            />
                        </div>
                    </div>

                    <Refresh refreshFunction={handleRefresh}/>
                </div>

                    <MmhTable columns={columns} data={filteredAssessments} loading={loading} section="my-reports"/>

                    <div className="mr-mt-3 table-pagination">
                        <div className="table-pagination__page-number">
                            <Pagination
                                currentPage={myPageNumber}
                                totalPages={Math.ceil(totalRecord / myPageSize)}
                                onPageChange={(page) => {
                                    setMyPageNumber(page)
                                }}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                            />
                        </div>
                        <div className="table-pagination__quantity-in-a-page">
                            <span className="table-pagination__info">Showing {((myPageNumber * myPageSize) - myPageSize) + 1} to {(myPageNumber * myPageSize)} of {totalRecord} entries</span>

                            <select
                                className="mr-select mr-select--small"
                                onChange={handlePageSize}
                                value={myPageSize}>
                                {getArrayFromObject(CONSTANT.PAGE_SIZE)?.map((item, index) => {
                                    return (
                                        <option key={index} value={item.value}>
                                            {item.name}
                                        </option>
                                    )
                                })}
                            </select>

                        </div>

                    </div>
            </div>
            {fysicalReportView && (
                <FysicalScoreReportView
                    open={fysicalReportView}
                    url={fysicalRportUrl}
                    toggleFysicalReportModal={toggleFysicalReportModal}>
                </FysicalScoreReportView>
            )}
            {reportUrl && (
                <DisplayUrlContent
                    headerTitle="Report"
                    open={!!reportUrl}
                    url={reportUrl}
                    onToggleModal={hideReportContent}>
                </DisplayUrlContent>
            )}
            {reportJsonView && (
                <ReportJsonViewer
                    open={reportJsonView}
                    reportData={reportJsonData}
                    isLoading={isLoadingReport}
                    toggleModal={toggleReportJsonModal}>
                </ReportJsonViewer>
            )}
            <AcademicCitationModal
                show={showCitationModal}
                onHide={onHideCitationModal}
                testId={selectedCitationTestId}
            />
        </>
    )
});

export default MyReportsDetails;
